import Vue from 'vue'
import Vuex from 'vuex'
import config from './config'
import {compare} from '../util/util'

import {
  UPDATE_USER_INFO,
  UPDATE_UID,
  UPDATE_THEME,
  UPDATE_FONTSIZE,
  UPDATE_TITLE_MAP,
  UPDATE_DELTA_HEIGHT
} from './mutation-type'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    config: config,
    customToken: null,
    uid: null,
    userInfo: {},
    theme: 'dark',
    fontSize: '19px',
    titleList: [],
    deltaHeight: 0,
    // socket.io
    connect: false
  },
  mutations: {
    [UPDATE_USER_INFO] (state, userInfo) {
      state.userInfo = userInfo
    },
    [UPDATE_UID] (state, uid) {
      state.uid = uid
    },
    [UPDATE_THEME] (state, theme) {
      state.theme = theme
    },
    [UPDATE_FONTSIZE] (state, fontSize) {
      state.fontSize = fontSize
    },
    [UPDATE_TITLE_MAP] (state, titleMap) {
      Vue.set(state, 'titleMap', titleMap)
    },
    [UPDATE_DELTA_HEIGHT] (state, deltaHeight) {
      state.deltaHeight = deltaHeight
    },
    // socket.io
    SOCKET_SHORTHANDSJOIN (state, [data]) {
      // console.log('join:', data)
      if (data.code === 0) {
        this.$socket.emit('setIsWebLogin', {isWebLogin: true})
      }
    },
    SOCKET_SETISWEBLOGIN (state, [data]) {
      // console.log('setIsWebLogin', data)
      if (data.code === 0) {
        state.connect = data.data.isWebLogin
        this.$socket.emit('config', {})
      }
    },
    SOCKET_CONFIG (state, [data]) {
      // console.log('config:', data)
      if (data.code === 0 && data.data) {
        state.theme = data.data.theme
        state.fontSize = data.data.fontSize
      }
    },
    SOCKET_DELETE (state, [data]) {
      // console.log('delete', data)
      if (data.code === 0) {
        this.$socket.emit('findAll')
      }
    },
    SOCKET_KEEP (state, [data]) {
      // console.log('keep:', data)
      if (data.code === 0) {
        this.$socket.emit('findAll')
      }
    },
    SOCKET_FINDALL (state, [data]) {
      // console.log('findAll', data)
      if (data.code === 0) {
        data.data.sort(compare('lastEditTime'))
        Vue.set(state, 'titleMap', data.data)
      }
    },
    SOCKET_DISCONNECT (state, [data]) {
      // console.log('disconnect')
      state.connect = false
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js